import { useCollection, useLinked } from "@type-r/react"
import React from "react"
import { Policy, PolicyBuyerSchedule } from "../../../api/policy"
import { AddBuyersStep } from "./add-buyers-step";
import { ConfirmBuyersDataStep } from "./confirm-buyers-data-step";
import { PolicyStoredBuyersTable } from "./policy-stored-buyers-table";

export const PolicyBuyersWorkflow = ({ policy }: { policy: Policy }) => {
    const buyers = useCollection.of(PolicyBuyerSchedule);
    const $workflowStep = useLinked(1);

    const goToconfirmBuyers = addedBuyers => {
        buyers.set(addedBuyers);
        $workflowStep.set(2);
    }

    const goBackToAddBuyers = () => {
        buyers.set([]);
        $workflowStep.set(1);
    }

    return <>
        { $workflowStep.value === 1 && <AddBuyersStep policy={ policy } next={ goToconfirmBuyers } /> }
        { $workflowStep.value === 2 && <ConfirmBuyersDataStep policy={ policy } buyers={ buyers } back={ goBackToAddBuyers } /> }
        <PolicyStoredBuyersTable buyers={ policy.policyBuyerSchedules } />
    </>
}